import React from "react";
import {
  Box,
  Stack,
  Container,
  Grid,
  Link,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import logo from "../../../assets/images/ForsteLogo.svg";
import Wave from "../../wave";
import theme from "../../../styles/theme";
import { useTranslation } from "react-i18next";
import { Link as LinkRouter } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <Wave
        amplitude={30}
        duration={10}
        fillStyle={theme.palette.background.dark}
        frequency={3}
        waveHeightRatio={0.3}
      />
      <Box
        sx={{
          color: "white",
          bgcolor: "background.dark",
          pb: 6,
          // mt: 5,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={10}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography
                variant="subtitle1"
                color="inherit"
                sx={{ fontWeight: "600" }}
                gutterBottom
              >
                {t("Footer.Legal.Label")}
              </Typography>
              <Link
                component={LinkRouter}
                to="/terms"
                variant="subtitle2"
                color="#D1D1D1"
                underline="hover"
                sx={{ fontWeight: "400" }}
              >
                {t("Footer.Legal.Terms")}
              </Link>
              <br />
              <Link
                component={LinkRouter}
                to="/terms"
                variant="subtitle2"
                color="#D1D1D1"
                underline="hover"
                sx={{ fontWeight: "400" }}
              >
                {t("Footer.Legal.Privacy")}
              </Link>
              <br />
              <Link
                variant="subtitle2"
                href="#"
                color="#D1D1D1"
                underline="hover"
                sx={{ fontWeight: "400" }}
              >
                {t("Footer.Legal.Cookies")}
              </Link>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography
                variant="subtitle1"
                color="inherit"
                sx={{ fontWeight: "600" }}
                gutterBottom
              >
                {t("Footer.Support.Label")}
              </Typography>
              <Link
                component={LinkRouter}
                to="/#contact"
                type="button"
                variant="subtitle2"
                onClick={() => {
                  const contactElement = document.getElementById("contact");
                  contactElement?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }}
                sx={{
                  fontWeight: "400",
                  color: "#D1D1D1",
                  textDecoration: "none",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {t("Footer.Support.Contact")}
              </Link>
            </Grid>
          </Grid>

          <Divider sx={{ bgcolor: "grey.700", my: 2, mt: 10 }} />

          <Grid
            container
            spacing={5}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: "600" }}>
                {t("Footer.Contact")}
              </Typography>
              <Typography variant="subtitle2" sx={{ fontWeight: "300" }}>
                {t("Email")}
              </Typography>
            </Grid>

            <Grid>
              <Stack direction="row" spacing={0}>
                <IconButton color="inherit" aria-label="Facebook">
                  <FacebookIcon />
                </IconButton>
                <IconButton color="inherit" aria-label="Instagram">
                  <InstagramIcon />
                </IconButton>
              </Stack>
            </Grid>
          </Grid>

          <Divider sx={{ bgcolor: "grey.700", my: 2 }} />

          <Grid container justifyContent="space-between" alignItems="center">
            <Grid display="flex" alignItems="center">
              <img src={logo} alt="Logo" height={35} />
              <Typography
                variant="h5"
                fontFamily="Century Gothic"
                sx={{ mx: 1, fontWeight: "800" }}
              >
                FØRSTEINNTRYKK
              </Typography>
            </Grid>

            <Typography
              variant="body2"
              fontSize={13}
              color="inherit"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
                justifyContent: { xs: "center", sm: "flex-end" },
                textAlign: { xs: "center", sm: "right" },
              }}
            >
              <Box component="span" sx={{ opacity: 0.6 }}>© 2026 Førsteinntrykk AS</Box>
              <Box component="span" sx={{ opacity: 0.6 }}>
                ·
              </Box>
              <Box component="span" sx={{ opacity: 0.6 }}>Org.nr. 916 912 854</Box>
              <Box component="span" sx={{ opacity: 0.6 }}>
                ·
              </Box>
              <Box component="span" sx={{ opacity: 0.6 }}>Alle rettigheter reservert.</Box>
            </Typography>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Footer;
